import { trackingAxios } from 'config/api/tracking';
import type { IWarehouseRepository } from '../domain/IWarehouseRepository';
import type { ErrorResponse, Warehouse } from '../domain/warehouse';

export class AxiosWarehouseRepository implements IWarehouseRepository {
    constructor() {}

    async addWarehouse(data: Warehouse): Promise<Warehouse> {
        try {
            const response = await trackingAxios.post<Warehouse>(
                '/warehouse',
                data
            )
            return response.data
        } catch (error) {
            const errorMessage =
                (error as ErrorResponse)?.response?.data?.message ??
                'Error al crear el warehouse'
            throw new Error(errorMessage)
        }
    }

    async getByCompanyId(companyId: string): Promise<Warehouse[]> {
        try {
            const response = await trackingAxios.get<Warehouse[]>(
                `/warehouse?companyId=${companyId}`
            )
            return response.data
        } catch (error) {
            console.error(
                '[AxiosWarehouseRepository] Error fetching warehouses:',
                error
            )
            throw error
        }
    }

    async delete(id: string): Promise<void> {
        try {
            await trackingAxios.delete(`/warehouse/${id}`)
        } catch (error) {
            console.error(
                '[AxiosWarehouseRepository] Error deleting warehouse:',
                error
            )
            throw error
        }
    }
}
